import { render, staticRenderFns } from "./UptimeApps.vue?vue&type=template&id=c3383a80&"
import script from "./UptimeApps.vue?vue&type=script&lang=js&"
export * from "./UptimeApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports